import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GovernanceSeverity } from '../../../../app/services/api/catalogueGovernance';

const SEVERITY_COLOR: Record<GovernanceSeverity, 'default' | 'warning' | 'error'> = {
  Low: 'default',
  Medium: 'warning',
  High: 'error',
  Critical: 'error',
};

/** Severity chip shared across Catalogue Governance tabs (Overview + Data Quality). */
const SeverityChip = ({ severity }: { severity: GovernanceSeverity }) => {
  const { t } = useTranslation('catalogueGovernance');
  return (
    <Chip
      label={t(`chips.severity.${severity}`, severity)}
      size="small"
      color={SEVERITY_COLOR[severity]}
      variant={severity === 'Critical' ? 'filled' : 'outlined'}
    />
  );
};

export default SeverityChip;
